module.exports = __webpack_public_path__ + "static/Understanding-New-User-Requirements-8f46ed84c94e32a3af1decc867b83b04.png";